var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LB_Symbol_colored_digital",
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.717,
    height: 132.929,
    viewBox: "0 0 147.717 132.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14337",
    "data-name": "Path 14337",
    d: "M178.877,73.591H160.292V64.716C160.292,52.632,150,42.8,137.341,42.8S114.39,52.632,114.39,64.716v8.875H95.652V64.716C95.652,52.632,85.358,42.8,72.7,42.8S49.75,52.632,49.75,64.716v8.875H31.16V64.716C31.16,42.843,49.793,25.05,72.7,25.05a42.253,42.253,0,0,1,32.32,14.771,42.244,42.244,0,0,1,32.32-14.771c22.9,0,41.536,17.793,41.536,39.666v8.875Zm-74.451,84.388L42.378,98.725,55.524,86.174l48.908,46.7,28.974-27.667,13.146,12.551Z",
    transform: "translate(-31.16 -25.05)",
    fill: "#f95047"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3c382d9714a4b061ca71d6dcf93de834.svg";
export { ForwardRef as ReactComponent };